import { render, staticRenderFns } from "./EnglishLanguageSupport.vue?vue&type=template&id=03b8801d"
import script from "./EnglishLanguageSupport.vue?vue&type=script&lang=js"
export * from "./EnglishLanguageSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports